import { Dimensions, FlatList, Image, PixelRatio, StyleSheet, Text, View } from 'react-native'
import React from 'react'
import Colours from '../utils/Colours';
import { TouchableOpacity } from 'react-native';

const { width, height } = Dimensions.get('window');
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
    const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
    const newSize = size * scaleFactor;

    return Math.round(PixelRatio.roundToNearestPixel(newSize));
};


const dynamicSize = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

const ATablesComp = ({ tableData }) => {
    return (
        <View style={styles.container}>
            <Text style={styles.tableName}>{tableData?.tableCaption}</Text>
            <Text style={styles.tableName2}>Table Value | 500,000</Text>
            {/* {selectedCelebratory?.images?.length > 0 && (<View style={styles.pictureGallaryStyles}> */}
            <View style={styles.pictureGallaryStyles}>

                <FlatList
                    data={tableData?.images}
                    horizontal
                    keyExtractor={(item, index) => index.toString()}
                    renderItem={({ item }) => (
                        <TouchableOpacity onPress={() => handleImagePress(item?.url)}>
                            <Image source={{ uri: item?.url }} style={styles.picImageContr} />
                        </TouchableOpacity>
                    )}
                />
            </View>
            {/* )} */}

        </View>
    )
}

export default ATablesComp

const styles = StyleSheet.create({
    container: {
        display: 'flex',
        padding: dynamicSpacing(15),
        borderRadius: dynamicSize(15),

        backgroundColor: Colours.PRIMARY_LIGHTER,
    },
    pictureGallaryStyles: {
        // flexDirection: 'row',
        // // margin: dynamicSpacing(15),
        // padding: dynamicSpacing(10),
        // backgroundColor: 'white',
        // borderRadius: dynamicSize(15),
        // gap: dynamicSpacing(10),
        marginTop: dynamicSpacing(5),

        borderTopWidth: 1,
        borderTopColor: Colours.DARKLIGHTGRAY,
    },
    picImageContr: {
        height: dynamicSize(60),
        width: dynamicSize(60),
        borderRadius: dynamicSize(15),
        marginRight: dynamicSpacing(10),
        marginTop: dynamicSpacing(5),
    },
    tableName: {
        color: Colours.DARKGRAY,
        // fontSize: 15,
        fontSize: dynamicFontSize(16),
        fontFamily: 'Sen-Bold',
    },
    tableName2: {
        color: Colours.PRIMARY,
        // fontSize: 15,
        fontSize: dynamicFontSize(12),
        fontFamily: 'Sen-Regular',
    },
})